import React from 'react';
import { BaseCheckbox } from '../../BaseCheckbox/BaseCheckbox';
import { makeStyles } from '@material-ui/core';

export type PSelectOption = {
  label: string | number;
  checked: boolean;
};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
}));

export const SelectOption: React.FC<PSelectOption> = (props) => {
  const { checked, label } = props;
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span>{label}</span>
      <BaseCheckbox checked={checked} />
    </div>
  );
};
